import { useQuery } from '@tanstack/react-query';

import { accountUserDetailKey } from '../common/queryKeys';
import AccountUserApi from '../../../../../lib/api/account/user/AccountUserApi';
import { setRequestForm } from '../../../../../lib/common';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  ACCOUNT_USER_DETAIL_ORDER_HISTORY_LIST_FILTER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_ORDER_SUMMARY_DATA_MODEL,
} from './models';

export const useAccountUserOrderDetailQuery = ({ userId, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'orderDetail', userId],
    async () => {
      const result = await AccountUserApi.getAccountUserOrderDetail(
        setRequestForm(
          {
            userId,
            orderHistory: {
              filterOption: ACCOUNT_USER_DETAIL_ORDER_HISTORY_LIST_FILTER_OPTION_MODEL,
              pagination: LIST_PAGINATION_MODEL,
            },
          },
          true,
        ),
      );
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: {
        data: {
          orderSummaryData: ACCOUNT_USER_DETAIL_ORDER_SUMMARY_DATA_MODEL,
        },
      },
    },
  );
};

export const useAccountUserDetailOrderListQuery = ({ userId, pagination, filterOption, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'orderList', pagination, filterOption, userId],
    async () => {
      const result = await AccountUserApi.getAccountUserDetailOrderList(
        setRequestForm({ userId, filterOption, pagination }, true),
      );
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: {
        data: {
          orderHistoryList: {
            list: [],
            totalCnt: 0,
          },
        },
      },
    },
  );
};
